var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 517,
    height: 434,
    viewBox: "0 0 517 434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M472 394h10v38.2h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M510.267 363.533c0 18.851-15.282 34.133-34.133 34.133-18.851 0-34.134-15.282-34.134-34.133C442 303.8 457.282 227 476.133 227c18.851 0 34.134 76.8 34.134 136.533z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.933 353.009h10V389.6h-10zM355.4 353.009h10V389.6h-10z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115 379h10v53.267h-10zM50 394h10v38.2H50z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.267 355.467c-.533-.013-6.884-.199-6.884 6.738 0 3.486 3.037 6.283 6.48 6.283h5.91c7.28 0 10.227 4.808 10.227 9.516V432.2l9.867.066v-51.2c0-10.12-3.141-19.164-12.279-23.483a24.838 24.838 0 0 0-3.963-1.463c-2.827-.786-5.523-.557-9.358-.653zM416.6 355.003c.533-.014 6.884-.199 6.884 6.738 0 3.486-3.037 6.282-6.48 6.282h-5.91c-7.28 0-10.227 4.81-10.227 9.517v54.196l-9.867.066v-51.2c0-10.12 3.141-19.164 12.279-23.483a24.838 24.838 0 0 1 3.963-1.463c2.827-.787 5.523-.557 9.358-.653z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.2 321.333c0 32.99-26.743 59.733-59.733 59.733-32.99 0-59.733-26.743-59.733-59.733 0-76.8 26.743-162.133 59.733-162.133 32.99 0 59.733 85.333 59.733 162.133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.734 377.485c-9.255 12.483-24.616 20.648-42.001 20.648-28.277 0-51.2-21.6-51.2-48.246 0-62.031 22.923-130.954 51.2-130.954 4.342 0 8.558 1.625 12.585 4.602"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M512 434H10a5 5 0 1 1 0-10h502a5 5 0 1 1 0 10z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M372.467 355.467H235.933a8.533 8.533 0 0 1-8.533-8.533v-17.067a8.533 8.533 0 0 1 8.533-8.533h136.533a8.533 8.533 0 0 1 8.533 8.533v17.067a8.532 8.532 0 0 1-8.532 8.533z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 37.307a7.652 7.652 0 0 1-7.652-7.653V7.652A7.652 7.652 0 0 1 125 0a7.652 7.652 0 0 1 7.653 7.652v22.001A7.653 7.653 0 0 1 125 37.307zM125 250a7.652 7.652 0 0 1-7.652-7.652v-22.001a7.652 7.652 0 0 1 7.652-7.653 7.652 7.652 0 0 1 7.653 7.653v22A7.653 7.653 0 0 1 125 250zM187.009 62.991a7.652 7.652 0 0 1 0-10.822l15.557-15.557a7.652 7.652 0 0 1 10.822 0 7.652 7.652 0 0 1 0 10.822l-15.557 15.557a7.652 7.652 0 0 1-10.822 0zM36.612 213.388a7.652 7.652 0 0 1 0-10.822l15.557-15.557a7.652 7.652 0 0 1 10.822 0 7.652 7.652 0 0 1 0 10.822l-15.557 15.557a7.652 7.652 0 0 1-10.822 0zM212.694 125a7.652 7.652 0 0 1 7.652-7.652h22.001A7.652 7.652 0 0 1 250 125a7.652 7.652 0 0 1-7.653 7.652h-22a7.652 7.652 0 0 1-7.653-7.652zM0 125a7.652 7.652 0 0 1 7.653-7.652h22A7.652 7.652 0 0 1 37.307 125a7.652 7.652 0 0 1-7.652 7.652H7.653A7.652 7.652 0 0 1 0 125zM187.009 187.009a7.652 7.652 0 0 1 10.822 0l15.557 15.557a7.652 7.652 0 0 1 0 10.822 7.652 7.652 0 0 1-10.822 0l-15.557-15.557a7.652 7.652 0 0 1 0-10.822zM36.612 36.612a7.652 7.652 0 0 1 10.822 0l15.557 15.557a7.652 7.652 0 0 1 0 10.822 7.652 7.652 0 0 1-10.822 0L36.612 47.434a7.652 7.652 0 0 1 0-10.822z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 69.954,
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M398.067 391.067H210.333v-10h187.733z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLine);
export default __webpack_public_path__ + "static/media/green-line.d0586941eb0e59ec928725ca0a510204.svg";
export { ForwardRef as ReactComponent };